import { articleListImageConfigurations }
  from './imageConfigurations';
import { Newsboard } from './graphql/api/graphql';

const getPartnerVariables = (
  newsboard: Newsboard,
) => ({
  newsboard,
  pageviews: false,
  partnerContent: true,
  first: 4,
  imageConfigurations: articleListImageConfigurations,
});

export default getPartnerVariables;
